import React, { Component } from 'react';
import format from 'date-fns/format';
import _ from 'lodash';
import { getGames, nextGame } from '~/tools/mll/helpers';
import Schedule from './Schedule';
import { months } from '~/tools/mll/headers';
import './styles.scss';

class TeamSchedule extends Component {
	state = {
		games: [],
		range: []
	}

	toMonth = (date) => {
		return format(date * 1000, 'MM');
	}

	componentDidMount = () => {
		getGames().then((res) => {
			this.setState({
				games: res,
				range: _.range(
					this.toMonth(res[nextGame(res)].schedule.gameTime),
					+this.toMonth(res[res.length-1].schedule.gameTime)+1
				)
			})
		}).catch((err) => {
			console.log(err);
		});
	}
	render() {
		return (
			<div className='team-schedule'>
			<h1 className='team-schedule-title site-border-color'>
				{`${new Date().getFullYear()} ${_.get(window.settings, 'companyName', '')} Schedule`}
			</h1>
			{ this.state.games.length?
					this.state.range.map((item, i) => (
						<div key={i}>	
							<h1 className='current-month'>{months[item-1]}</h1>
							<div className='games-wrapper'>
							{ this.state.games.map((game, ii) => (
								item === +this.toMonth(game.schedule.gameTime) &&
								game.schedule.gameTime * 1000 > Date.now() ? 
								<Schedule
									key={ii}
									siteName={window.settings.companyName}
									homeTeam={game.homeTeam}
									awayTeam={game.awayTeam}
									schedule={game.schedule}
									ticket={game.ticket}
									stream={game.stream}
									link={game.link}
								/>
								: ''
							)) }
							</div>
						</div>
					)) : <div className='no-games'>No games at the moment.</div> }
			</div>
		)
	}
}

export default TeamSchedule;